import { useEffect, useRef } from "react";

/**
 * This is effect that is executed only on the component updates and not
 * executed on the initial component mounting.
 */
export const useUpdateEffect: typeof useEffect = (effect, deps) => {
    const isInitial = useRef(true);
    useEffect(() => {
        if (isInitial.current) {
            isInitial.current = false;
            return;
        }

        return effect();
    }, deps);
};
